export default __webpack_public_path__ + "img/fplFLmeB.7c793911.svg";